/* ============================================
   Cura — Shop by Concern Carousel
   Vanilla JS. Arrow scroll by one card,
   disabled state at the ends, editor-safe.
   ============================================ */

(function () {
  'use strict';

  function initConcernCarousel(root) {
    if (!root || root.dataset.cccInit === 'true') return;
    root.dataset.cccInit = 'true';

    var track = root.querySelector('[data-ccc-track]');
    var prevBtn = root.querySelector('[data-ccc-prev]');
    var nextBtn = root.querySelector('[data-ccc-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function cardStep() {
      var item = track.querySelector('.cura-ccc__item');
      if (!item) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });

    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(updateArrows, 80);
    }, { passive: true });

    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('[data-cura-concern]').forEach(initConcernCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor: re-init when the section is (re)loaded */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-cura-concern]');
    if (root) {
      root.dataset.cccInit = 'false';
      initConcernCarousel(root);
    }
  });
})();